import { createSelector } from 'reselect';

export interface CountriesState {
  loading: boolean;
  countries: any[];
  error: string;
}

export const initialState: CountriesState = {
  loading: false,
  countries: [],
  error: '',
};

const getCountries = ({ countries }: any): CountriesState => countries;

export const countriesSelectors = {
  getCountries: createSelector(
    [getCountries],
    ({ countries }) => countries,
  ),

  getLoading: createSelector(
    getCountries,
    ({ loading }) => loading,
  ),
};



// WEBPACK FOOTER //
// ./src/scenes/Countries/services/selectors.ts